import { Moon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { SleepStepContainer } from "../SleepStepContainer"
import { useSleepForm } from "../SleepFormContext"

interface SoundStepProps {
  sounds: { id: string; name: string }[]
  childName?: string
  onNext: () => void
}

export function SoundStep({ sounds, childName, onNext }: SoundStepProps) {
  const form = useSleepForm()

  return (
    <SleepStepContainer>
      <div className="space-y-2">
        <h3 className="text-lg font-medium text-center mb-4">
          What sound was used for sleep?
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
          {sounds.map((sound) => (
            <Button
              key={sound.id}
              type="button"
              variant={form.watch("sound_id") === sound.id ? "default" : "outline"}
              className="w-full py-3 px-4 h-auto text-left justify-start hover:bg-accent/50 whitespace-normal"
              onClick={() => {
                form.setValue("sound_id", sound.id)
                form.clearErrors("sound_id")
                onNext()
              }}
            >
              <Moon className="mr-2 h-4 w-4 shrink-0" />
              <span className="text-sm line-clamp-2">{sound.name}</span>
            </Button>
          ))}
        </div>
      </div>
    </SleepStepContainer>
  )
}